import Vue, { DirectiveOptions } from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/styles/dashboard.scss'
import App from '@/App.vue'
import store from '@/store'
import { AppModule } from '@/store/modules/app'
import router from '@/router'
import i18n from '@/lang'
import '@/icons/components'
import '@/permission'
import '@/utils/error-log'
// import '@/pwa/register-service-worker'
import { checkPermission, checkNeedAudit } from '@/utils/permission'
import * as directives from '@/directives'
import * as filters from '@/filters'
import GoogleAndAuditDialog from '@/components/GoogleAndAuditDialog/index.vue'

// import * as Sentry from '@sentry/vue'

// if (process.env.NODE_ENV !== 'development') {
//   Sentry.init({
//     Vue,
//     dsn: "https://2c39dc3ee8582336a20c5deb1ab7645a@o4506653749673984.ingest.sentry.io/4506654090854400",
//     integrations: [
//       new Sentry.BrowserTracing({
//         // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//         tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//       }),
//       new Sentry.Replay({
//         maskAllText: false,
//         blockAllMedia: false,
//       }),
//     ],
//     environment: process.env.NODE_ENV,
//     release: `asiapay-admin@1.0.0`,
//     // Performance Monitoring
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   })
// }

import '@/utils/AutoUpdate'
// 前端重新部署通知用户刷新网页
// import Updater from './utils/AutoUpdate'
// const AutoUpdate = new Updater()

// AutoUpdate.on('update', () => {
//   setTimeout(async () => {
//     ElementUI.MessageBox({
//       title: 'Tips',
//       message: 'The current website has updates, please refresh the page',
//       callback: action => {
//         location.reload()
//       }
//     })
//   }, 500)
// })

declare global {
  interface Window {
    ClipboardItem: any
    atob: any
  }
}

// 打印插件
import Print from 'vue-print-nb'
Vue.use(Print) // 注册

// 将我们注册的国际化组件实例诸如element中
Vue.use(ElementUI, {
  size: AppModule.size, // Set element-ui default size
  i18n: (key: string, value: string) => i18n.t(key, value)
})

Vue.use(SvgIcon, {
  tagName: 'svg-icon', // 图标组件名称
  defaultWidth: '1em',
  defaultHeight: '1em'
})

// Register global directives
Object.keys(directives).forEach(key => {
  Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key])
})

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string]: Function })[key])
})

Vue.config.productionTip = false

Vue.prototype.checkPermission = checkPermission
Vue.prototype.checkNeedAudit = checkNeedAudit
Vue.component('gaa', GoogleAndAuditDialog)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
